import React, { useEffect, useRef } from "react";
import "./style.css";
import { Link } from "react-router-dom";
const Market = ({ data }) => {
  const sectionRef = useRef(null);
  useEffect(() => {
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.1,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const items = entry.target.querySelectorAll(".overlay");

        if (entry.isIntersecting) {
          items.forEach((item, index) => {
            setTimeout(() => {
              item.classList.add("translate-y-full");
              item.classList.remove("translate-y-reset");
            }, index * 500); // 500ms delay for each item
          });
        } else {
          // Reset the animation when the section goes out of view
          items.forEach((item) => {
            item.classList.remove("translate-y-full");
            item.classList.add("translate-y-reset");
          });
        }
      });
    }, options);

    observer.observe(sectionRef.current);

    return () => observer.disconnect();
  }, []);

  return (
    <section
      ref={sectionRef}
      className={`scroll-section w-full overflow-hidden hidden lg:block`}
    >
      <div className="h-full flex relative ">
        <div className="absolute text-center  left-1/2 top-32 z-[100] -translate-x-1/2">
          <h4 className="text-white uppercase text-4xl tracking-wider">Our </h4>
          <p className="text-8xl bebas  uppercase text-white tracking-wider">
            Solutions
          </p>
        </div>
        <div className="grid grid-cols-4 w-full">
          {data?.map(({ image, name, description, slug }, index) => (
            <Link
              to={`/market-segments/${slug}`}
              className="h-full min-w-full relative  group border-l-[0.5px] border-r-[0.5px] border-[#3b3b3b]"
              key={index}
            >
              <img
                className="grayscale opacity-50 transition ease-in duration-500 w-full group-hover:grayscale-0 group-hover:opacity-100"
                src={image}
                alt={name}
              />
              {/* overlay */}
              {/* <div className="overlay absolute top-0 left-0 w-full h-full transition ease-in duration-700 translate-y-[0%] bg-[#0000009a] group-hover:translate-y-[-100%] z-[0] "></div> */}
              {/* content */}
              <div className="absolute transition ease-in duration-500 left-0 right-0 px-8 bottom-24  h-auto group-hover:h-max w-full z-[100] group-hover:bg-[#000000a4] py-10">
                <h4 className="text-white text-4xl font-bold capitalize group-hover:hidden">
                  {name}
                </h4>
                <h4 className="text-white text-4xl font-bold transition ease-in duration-1000 capitalize hidden  group-hover:block">
                  {name}
                </h4>

                <div
                  className="mt-1 opacity-0 translate-y-4 group-hover:opacity-100 group-hover:translate-y-0 transition ease-in duration-300 text-white !font-bold "
                  dangerouslySetInnerHTML={{ __html: description }}
                />
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Market;
